import React from 'react';
import { useTranslation } from 'react-i18next';
import { Contacts } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';

export function ContactsPage() {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('contacts-component.metatags.title', { marketplace: allSettings?.data?.marketplaceName }),
        description: t('contacts-component.metatags.description', { marketplace: allSettings?.data?.marketplaceName }),
    };

    const seoImage = allSettings?.data?.content_headers_contacts_image;

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        image: seoImage?.src
            ? {
                  src: seoImage.src || '',
                  type: seoImage.type,
                  width: seoImage.width,
                  height: seoImage.height,
                  alt: translations.title || '',
              }
            : undefined,
        url: SITE_URLS.contacts,
        index: true,
    });

    return <Contacts />;
}
